import supabase from '../supabase';

const dbManager = {

  saveScore: async function (username, score) {
    try {
      // Insert a new score for the user
      const { error } = await supabase
        .from('scores')
        .insert([{ username, score }]);
  
      if (error) {
        console.error("Error inserting score:", error.message);
      } else {
        console.log("Score saved successfully!");
      }
    } catch (error) {
      console.error("Error saving score:", error);
    }
  },
  

  // Get top scores: Returns the top N scores sorted in descending order
  getTopScores: async function (limit = 10) {
    try {
      const { data, error } = await supabase
        .from('scores')
        .select('*')
        .order('score', { ascending: false })
        .limit(limit);

      if (error) {
        console.error("Error fetching top scores:", error.message);
        return [];
      }

      return data;
    } catch (error) {
      console.error("Error fetching top scores:", error);
      return [];
    }
  },

  // // Get a single user's score: Returns the score for a given username
  // getUserScore: async function (username) {
  //   try {
  //     const { data, error } = await supabase
  //       .from('scores')
  //       .select('score')
  //       .eq('username', username)
  //       .single();

  //     if (error) {
  //       console.error(`Error fetching score for ${username}:`, error.message);
  //       return null;
  //     }
  //     return data ? data.score : null;
  //   } catch (error) {
  //     console.error(`Error fetching score for ${username}:`, error);
  //     return null;
  //   }
  // },

  // Delete a score: Deletes a user by username
  // deleteScore: async function (username) {
  //   try {
  //     const { error } = await supabase
  //       .from('scores')
  //       .delete()
  //       .eq('username', username);

  //     if (error) {
  //       console.error(`Error deleting score for ${username}:`, error.message);
  //     } else {
  //       console.log(`Score for ${username} deleted.`);
  //     }
  //   } catch (error) {
  //     console.error(`Error deleting score for ${username}:`, error);
  //   }
  // },

  // // Check if a user exists by username
  // userExists: async function (username) {
  //   try {
  //     const { data, error } = await supabase
  //       .from('scores')
  //       .select('username')
  //       .eq('username', username)
  //       .single();

  //     if (error && error.code === 'PGRST100') {
  //       // No user found
  //       return false;
  //     }

  //     if (data) {
  //       return true; // User exists
  //     }

  //     return false; // Unknown error
  //   } catch (error) {
  //     console.error(`Error checking if user exists:`, error);
  //     return false;
  //   }
  // },
};

export default dbManager;
